import { toSimpleUtcDateString } from 'src/utils/format/date';
import { CAP_DEVELOPMENT, CAP_IMPLEMENTATION, CAP_COMPLETED } from 'src/utils/data/job';

export const getCapFinding = (finding) => {
  const actionDueDates = (finding?.actions || []).filter(({ dueDate }) => dueDate).map(({ dueDate }) => new Date(dueDate));
  let maxDueDate = '-';
  if (actionDueDates.length) {
    const maximumDate = new Date(Math.max.apply(null, actionDueDates));
    maxDueDate = toSimpleUtcDateString(maximumDate);
  }

  return {
    maxDueDate,
    reviewMethod: finding?.nonComplianceReviewMethod,
    actionCount: finding?.actions?.length || 0,
    category :finding?.nonComplianceCategory || '-',
    categoryContent :finding?.nonCompliance || '-',
    detailedFinding: finding?.detailedFinding || 'N/A',
    findingStatus: finding?.status || 'N/A',
    legalRequirement: finding?.legalRequirements || 'N/A',
    rootCause: finding?.rootCause,
    recommendations: finding?.recommendations || 'N/A',
    severity: finding?.info?.criticality || 'N/A',
    actions: finding?.actions || [],
  };
};

export const REVIEW_METHOD = {
  "onsite": 'ONSITE_VERIFICATION',
  "desktop": "DESKTOP_VERIFICATION",
};

export const FINDING_STATUS = {
  'review_pending': { text: 'REVIEW_PENDING', class: 'bg-navy-100 text-white' },
  'revision_requested': { text: 'REVISION_REQUESTED', class: 'bg-plum-100 text-white' },
  'approved': { text: 'APPROVED', class: 'bg-sea-100 text-white' },
  'open_action_pending': { text: 'OPEN_ACTION_PENDING', class: 'bg-high text-white' },
  'evidence_review_pending': { text: 'EVIDENCE_REVIEW_PENDING', class: 'bg-aqua-100 text-navy-100' },
  'open_in_process': { text: 'OPEN_IN_PROCESS', class: 'bg-medium text-black' },
  'tentatively_closed_onsite_verification_required': { text: 'TENTATIVELY_CLOSED_ONSITE_VERIFICATION', class: 'bg-mint text-black' },
  'closed_desktop_verified': { text: 'CLOSED_DESKTOP_VERIFIED', class: 'bg-inputColor text-white' },
  'Open': { text: 'OPEN', class: 'bg-gray' },
  'Closed': { text: 'CLOSED', class: 'bg-green' },
  'Not required': { text: 'NOT_REQUIRED', class: 'bg-gray' },
};

export const SEVERITY = {
  'Zero Tolerance': { text: 'ZERO_TOLERANCE', class: 'bg-black text-white' },
  'Critical': { text: 'CRITICAL', class: 'bg-extreme text-white' },
  'Major': { text: 'MAJOR', class: 'bg-high text-white' },
  'Moderate': { text: 'MODERATE', class: 'bg-medium text-black' },
  'Minor': { text: 'MINOR', class: 'bg-midGray text-black' },
  'N/A': { text: 'N/A', class: 'bg-midGray text-white' }
}


export const hideAddAction = (findingStatus, jobStatus, isCapManager, capType) =>{
  /* If job status = CAP implementation / CAP complete, hide the ‘Add action’ button */
  if(jobStatus === CAP_COMPLETED){
    return true
  }
  
  if(capType === 'desktop_evidence_review' ){
    const EXTERNAL_USER_HIDE_ADD_ACTION_BTN_STATUS_FOR_DESKTOP_EVIDENCE_REVIEW = ['review_pending', 'approved', 'evidence_review_pending', 'tentatively_closed_onsite_verification_required', 'closed_desktop_verified']
    return  isCapManager ? true : (!findingStatus || EXTERNAL_USER_HIDE_ADD_ACTION_BTN_STATUS_FOR_DESKTOP_EVIDENCE_REVIEW.includes(findingStatus?.toLowerCase()));
  }

  if(jobStatus === CAP_IMPLEMENTATION){
      return true
  }
  /* If job status = CAP development, then we need to further check on finding status */
  /* ‘Add action’ button should be hidden, when the finding status = ‘Review pending, ‘Approved’, ‘Open - action pending’, */
  /* ‘Evidence review pending’, ‘Open-in process’, ‘Tentatively closed - onsite verification required', */
  /* ‘Closed - desktop verified’ */
  /* (Means that button is only available in first time creating action and finding status in 'Revision requested') */
  const EXTERNAL_USER_HIDE_ADD_ACTION_BTN_STATUS = ['review_pending', 'approved', 'open_action_pending', 'evidence_review_pending', 'open_in_process', 'tentatively_closed_onsite_verification_required', 'closed_desktop_verified'];
  
  return  isCapManager ? true : (!findingStatus || EXTERNAL_USER_HIDE_ADD_ACTION_BTN_STATUS.includes(findingStatus?.toLowerCase()));
};